// extracted by mini-css-extract-plugin
module.exports = {"title":"pageTitle_title__1O95P"};